import React from "react"
import Header from "./header"
import { RightOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons"
import './setup.css'
import { Button } from "antd"

export const PaymentResultContainer = ({ history, logOut, status }) => {
    const onClickStart = () => {
        if (status === "success") history.push('/onboarding/ready')
        else history.push('/membership-selection')
    }

    return (
        <div className="set-up-screen">
            <Header history={history} logOut={logOut} />
            <div className="ready-container">
                <div className="ready">
                    <div className="title" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        {status === 'success' ? (
                            <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 32 }} />
                        ) : (
                            <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: 32 }} />
                        )}
                    </div>
                    <div className="title" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        Payment {status === "success" ? "Successful" : "Failed"}
                    </div>
                    <div className="desc" style={{ marginTop: 16, marginBottom: 8 }}>
                        {status === 'success' ? (
                            <>
                                <div style={{ fontWeight: 500, fontSize: 18, color: '#333', marginBottom: 8 }}>
                                    Thanks for choosing Apeiron!
                                </div>
                            </>
                        ) : (
                            <>
                                <div style={{ fontWeight: 500, fontSize: 18, color: '#e74c3c', marginBottom: 8 }}>
                                    Payment failed. Please try again.
                                </div>
                                <div style={{ color: '#555' }}>
                                    If you continue to experience issues, contact support at <a href="mailto:accounting@apeiron.life">accounting@apeiron.life</a>.
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <Button type="primary" className="cta" onClick={onClickStart}>
                    {status === "success" ? "Back to Onboarding Questionnaire" : "Try Again"} <RightOutlined />
                </Button>
            </div>
        </div>
    )
}